import { Alert, Button, List, Space } from 'antd';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import EntranceMotion from '../../../helpers/components/entrance_motion';
import numberHelper from '../../../helpers/functions/number.helper';

const OrderInsuranceList = () => {
    const purchaseRedux = useSelector(state => state.purchase);
    const ticketRedux = useSelector(state => state.ticket);
    const currency = ticketRedux?.park?.currency?.symbol;
    
    // Get available add-ons from Redux (set by purchase_add_on component)
    const availableAddOns = ticketRedux?.available_add_ons || [];

    // Calculate total tickets
	const totalTickets = useMemo(() => {
		// Extract all valid ticket_applicable_user_id into matchIds
		// Assuming ticketRedux.add_on_applicable_ticket_users is an array
		const allMatchIds = (ticketRedux.add_on_applicable_ticket_user || [])
			.filter(u => u && u.ticket_applicable_user_id != null)
			.map(u => u.ticket_applicable_user_id);


		// Remove duplicates if needed
		const uniqueMatchIds = [...new Set(allMatchIds)];

		return (purchaseRedux?.ticket_users || []).reduce((sum, ticket) => {
			if (uniqueMatchIds.includes(ticket?.ticket_applicable_user_id)) {
				return sum + (ticket?.quantity || 0);
			}
			return sum;
		}, 0);
	}, [JSON.stringify(purchaseRedux?.ticket_users)]);
    // Check if park has insurance configured (from available add-ons in database)
    // availableAddOns comes from the backend response in purchase_add_on component
    const parkHasInsurance = useMemo(() => {
        return availableAddOns?.some(addon =>
			addon?.add_on?.add_on_section?.is_insurance === true
        ) || false;
    }, [availableAddOns]);

    // Filter insurance items that are IN CART
    const insuranceItemsInCart = useMemo(() => {
        return purchaseRedux?.add_ons?.filter(addon =>
			addon?.add_on_section?.is_insurance === true
        ) || [];
    }, [JSON.stringify(purchaseRedux?.add_ons)]);

    // Show warning only if:
    // 1. Park has insurance configured (backend returned insurance)
    // 2. User has tickets selected
    // 3. User has NOT added insurance to cart
    const shouldShowWarning = parkHasInsurance && totalTickets > 0 && insuranceItemsInCart.length === 0;
    // Don't render anything if park doesn't have insurance configured
    if (!parkHasInsurance) {
        return null;
    }

    return (
        <>
            {/* Show warning if has tickets but no insurance selected */}
			{shouldShowWarning && (
				<EntranceMotion>
					<Alert
						message="Add insurance for protection and peace of mind—for you and your loved ones"
						type="warning"
						showIcon
						style={{
							fontSize: 12,       // smaller text
							padding: '4px 8px', // reduce padding
							lineHeight: '16px', // tighter line height
						}}
					/>
				</EntranceMotion>
			)}

			{/*/!* Show insurance list if insurance is in cart *!/*/}
            {/*{insuranceItemsInCart.length > 0 && (*/}
            {/*    <>*/}
            {/*        <div style={{textAlign:'left', paddingInline: 24, marginTop: 12, }}>*/}
            {/*            <span style={{fontWeight:500, fontSize:16, color:'var(--main-color)'}}>Insurance</span>*/}
            {/*        </div>*/}
            {/*        <div>*/}
            {/*            <List*/}
            {/*            dataSource={insuranceItemsInCart}*/}
            {/*            renderItem={(item, index) => {*/}
            {/*                const { name, price, quantity } = item ?? {};*/}

            {/*                // Insurance never has promotions - always use base price*/}
            {/*                const sub_total = price * quantity;*/}
            {/*                */}
            {/*                return (*/}
            {/*                    <List.Item style={{ paddingInline : 24, }}>*/}
            {/*                        <EntranceMotion initialY={-50} duration={1} style={{width : '100%'}}>*/}
            {/*                            <div style={{fontSize:14, display:'flex', textAlign:'left'}}>*/}
            {/*                                <div>*/}
            {/*                                    <div>*/}
            {/*                                        <span>{name}</span>*/}
            {/*                                    </div>*/}
            {/*                                    <div>*/}
            {/*                                        <Space>*/}
            {/*                                            <div>*/}
            {/*                                                <span className='ticket-label' style={{fontWeight:500, fontSize:14}}>*/}
            {/*                                                    {`${currency}${numberHelper?.commaNumber(sub_total)}`}*/}
            {/*                                                </span>*/}
            {/*                                            </div>*/}
            {/*                                            <div>*/}
            {/*                                                <span style={{fontSize:12, color:'var(--secondary-text-color)'}}>*/}
            {/*                                                    ({quantity} ticket{quantity > 1 ? 's' : ''})*/}
            {/*                                                </span>*/}
            {/*                                            </div>*/}
            {/*                                        </Space>*/}
            {/*                                    </div>*/}
            {/*                                </div>*/}
            {/*                                <div style={{marginLeft:'auto'}}>*/}
            {/*                                    <Space>*/}
            {/*                                        <div>*/}
            {/*                                            <span>*/}
            {/*                                                {quantity}*/}
            {/*                                            </span>*/}
            {/*                                        </div>*/}
            {/*                                    </Space>*/}
            {/*                                </div>*/}
            {/*                            */}
            {/*                            </div>*/}
            {/*                        </EntranceMotion>*/}
            {/*                    </List.Item>*/}
            {/*                )*/}
            {/*            }}*/}
            {/*            />*/}
            {/*        </div>*/}
            {/*    </>*/}
            {/*)}*/}
        </>
    );
}

export default OrderInsuranceList;